import { Switch, Route, withRouter } from 'react-router-dom';
import { patientIntakeTabs } from '@nkr/views/recipients/patient-intake/list/nav';
import CenterAdmin from '@nkr/views/center-admin';

const CenterPassRoutes = (params) => {
    let url = params.url;

    return (
        <Route
            path={`${params.url}/patient-intake`}
            render={({ match: { url, params: followUpParams } }) => (
                <Switch>
                    {patientIntakeTabs.map(tab =>
                        <Route exact path={`${url}/${tab.url}`} render={({ match: { params: subParams } }) =>
                            <CenterAdmin {...subParams} centerId={parseInt(params.id)} section='RECIPIENTS' subSection='PATIENT-INTAKE-LIST' tertiarySection={tab.key} />} />
                    )}

                    <Route exact path={`${url}`} render={({ match: { params: subParams } }) =>
                        <CenterAdmin {...subParams} centerId={parseInt(params.id)} section='RECIPIENTS' subSection='PATIENT-INTAKE-LIST' tertiarySection='TO-DO' />} />
                </Switch>
            )}
        />
    );
}

export default withRouter(CenterPassRoutes);